export default {"src":"__ASTRO_ASSET_IMAGE__084e944d__","width":58,"height":24,"format":"svg"}